import React from 'react';

export const Tariff = () => {
  return (
    <>
      Tariff page
    </>
  )
}